import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import PageHeader from "../../components/PageHeader";
import Button from "../../components/Button";
import SearchInput from "../../components/SearchInput";
import DataTable, { type Column } from "../../components/DataTable";
import Pagination from "../../components/Pagination";
import { useArtistsList } from "../../../hooks/useArtistsList";
import { useDeleteArtist } from "../../../hooks/useDeleteArtist";
import type { ArtistResponse } from "../../../api/artistsApi";

export default function ArtistListPage() {
  const navigate = useNavigate();
  const [page, setPage] = useState(0);
  const [search, setSearch] = useState("");
  const { data, isLoading } = useArtistsList({ search, page, size: 20, sort: "name,asc" });
  const remove = useDeleteArtist();

  const onDelete = (id: string) => {
    if (window.confirm("Supprimer définitivement cet artiste ?")) remove.mutate(id);
  };

  const columns: Column<ArtistResponse>[] = [
    {
      key: "name",
      header: "Nom",
      render: (row) => (
        <Link to={`/admin/artists/${row.id}`} className="bo-cell-link">
          {row.name}
        </Link>
      ),
    },
    {
      key: "description",
      header: "Description",
      render: (row) => {
        const d = row.description ?? "";
        return d.length > 100 ? d.slice(0, 100) + "…" : d || "—";
      },
    },
    {
      key: "lieux",
      header: "Lieux",
      render: (row) => row.lieux?.length ?? 0,
    },
    {
      key: "actions",
      header: "",
      render: (row) => (
        <div className="bo-row-end">
          <Button variant="ghost" onClick={() => navigate(`/admin/artists/${row.id}`)}>
            Éditer
          </Button>
          <Button variant="ghost" onClick={() => onDelete(row.id)}>
            Supprimer
          </Button>
        </div>
      ),
    },
  ];

  return (
    <div>
      <PageHeader
        title="Artistes"
        description="Catalogue global des artistes du tenant. Les artistes sont ensuite attachés aux parcours et aux lieux."
        actions={
          <Button variant="primary" onClick={() => navigate("/admin/artists/new")}>
            + Nouvel artiste
          </Button>
        }
      />

      <div className="bo-toolbar">
        <SearchInput
          value={search}
          onChange={(v) => {
            setSearch(v);
            setPage(0);
          }}
          placeholder="Rechercher par nom ou description…"
        />
      </div>

      <DataTable
        rows={data?.content}
        columns={columns}
        rowKey={(r) => r.id}
        loading={isLoading}
        emptyMessage="Aucun artiste pour le moment."
      />
      <Pagination page={page} totalPages={data?.totalPages ?? 0} onChange={setPage} />
    </div>
  );
}
